export default __webpack_public_path__ + "static/media/google-icon.0dd78068.svg";